const styles = {
  container: {
    display: 'flex',
    flexFlow: 'row wrap',
    alignContent: 'center',
    justifyContent: 'center',
    minHeight: '24em',
    margin: '0 25px',
  },
  icon: {
    fontSize: '2.5em',
    flex: '1 1 100%',
    color: 'green',
    textAlign: 'center',
    fontFamily: 'TTCommons'
  },
  h1: {
    flex: '1 1 100%',
    textAlign: 'center',
    fontSize: '2.5em',
    fontFamily: 'TTCommons'
  },
  message: {
    flex: '1 1 100%',
    margin: 0,
    fontSize: '1.5em',
    textAlign: 'center',
    lineHeight: 1.5,
    fontFamily: 'TTCommons'
  },
  messageSmall: {
    fontSize: '1em',
    fontFamily: 'TTCommons'
  },
  refererBlock: {
    textAlign: 'center',
  },
  refererBtn: {
    marginTop: '15px',
  },
  textThankYou: {
    flex: '1 1 100%',
    textAlign: 'center',
    fontSize: '2.5em',
    fontFamily: 'TTCommons',
    fontWeight: 'bold'
  }
};

export default styles;